import React from 'react';

const AudienceAnalytics: React.FC = () => {
  return (
    <section id="audience-analytics" className="mb-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Demographics */}
        <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
          <h3 className="text-lg font-semibold text-white mb-4">Kitle Demografisi</h3>
          <div className="space-y-4">
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">18-24 Yaş</span>
                <span className="text-white text-sm">28%</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-purple-500 to-purple-700 w-7/12"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">25-34 Yaş</span>
                <span className="text-white text-sm">35%</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-blue-400 to-blue-600 w-4/5"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">35-44 Yaş</span>
                <span className="text-white text-sm">22%</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-green-400 to-green-600 w-1/2"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">45+ Yaş</span>
                <span className="text-white text-sm">15%</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-pink-400 to-pink-600 w-1/3"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Geographic Distribution */}
        <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
          <h3 className="text-lg font-semibold text-white mb-4">En İyi Konumlar</h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-4 bg-blue-400 rounded-sm"></div>
                <span className="text-white/80 text-sm">Amerika Birleşik Devletleri</span>
              </div>
              <span className="text-white text-sm">42%</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-4 bg-green-400 rounded-sm"></div>
                <span className="text-white/80 text-sm">Birleşik Krallık</span>
              </div>
              <span className="text-white text-sm">18%</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-4 bg-purple-400 rounded-sm"></div>
                <span className="text-white/80 text-sm">Canada</span>
              </div>
              <span className="text-white text-sm">12%</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-4 bg-pink-400 rounded-sm"></div>
                <span className="text-white/80 text-sm">Australia</span>
              </div>
              <span className="text-white text-sm">10%</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-4 bg-yellow-400 rounded-sm"></div>
                <span className="text-white/80 text-sm">Germany</span>
              </div>
              <span className="text-white text-sm">8%</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-4 bg-cyan-400 rounded-sm"></div>
                <span className="text-white/80 text-sm">Diğerleri</span>
              </div>
              <span className="text-white text-sm">10%</span>
            </div>
          </div>
        </div>

        {/* Engagement Times */}
        <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
          <h3 className="text-lg font-semibold text-white mb-4">En İyi Paylaşım Zamanları</h3>
          <div className="space-y-4">
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">Pazartesi 14-16</span>
                <span className="text-green-400 text-sm">Yüksek</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-green-400 w-4/5"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">Salı 18-20</span>
                <span className="text-green-400 text-sm">Yüksek</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-green-400 w-5/6"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">Çarşamba 12-14</span>
                <span className="text-yellow-400 text-sm">Orta</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-yellow-400 w-3/5"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">Cuma 15-17</span>
                <span className="text-yellow-400 text-sm">Orta</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-yellow-400 w-2/3"></div>
              </div>
            </div>
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="text-white/70 text-sm">Hafta Sonu</span>
                <span className="text-red-400 text-sm">Düşük</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                <div className="h-full bg-red-400 w-1/3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceAnalytics;
